import { useQuery } from '@tanstack/react-query';
import { githubApi } from '../api/github';

export function useGithubSummary() {
  return useQuery({
    queryKey: ['github', 'summary'],
    queryFn: githubApi.getSummary,
    refetchInterval: 45_000,
    staleTime: 20_000,
    retry: false,
  });
}
